// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import documentVersionEntity from './entities/document-version.json';
import documentVersionMenu from '../pages/document-version/menu.json';
import documentVersionFullForm from '../pages/document-version/forms/full.json';
import documentVersionContextForm from '../pages/document-version/forms/context.json';
import documentVersionMiniForm from '../pages/document-version/forms/mini.json';
import documentVersionLookupForm from '../pages/document-version/forms/lookup.json';
import documentVersionTableView from '../pages/document-version/views/table.json';
import documentVersionCardsView from '../pages/document-version/views/cards.json';
import documentVersionCalendarView from '../pages/document-version/views/calendar.json';
import documentVersionDashboardView from '../pages/document-version/views/dashboard.json';

/** Тип запису «Версія документа» зі сторінками пакета: меню, форми та подання з pages/document-version/. */
export const documentVersionDefinition: IRecordTypeDefinition = {
  ...documentVersionEntity,
  views: assembleViewSet({
      table: documentVersionTableView,
      cards: documentVersionCardsView,
      calendar: documentVersionCalendarView,
      dashboard: documentVersionDashboardView,
  }),
  form: documentVersionFullForm,
  forms: { full: documentVersionFullForm, context: documentVersionContextForm, mini: documentVersionMiniForm, lookup: documentVersionLookupForm },
  menu: documentVersionMenu,
} as IRecordTypeDefinition;
